import { z } from 'zod';

export default function useStage(): Stage {
  // return 'SHOW_WINNERS';
  // return 'SHOW_FINALISTS';
  // return 'SHOW_PRODUCTS';
  // return 'HIDE_ALL_PRODUCTS';
  return stage.parse(process.env.GATSBY_SITE_STAGE);
}

export const stage = z
  .enum([
    'HIDE_ALL_PRODUCTS',
    'SHOW_PRODUCTS',
    'SHOW_FINALISTS',
    'SHOW_WINNERS',
  ])
  .default('SHOW_PRODUCTS');

export type Stage = z.infer<typeof stage>;
